import axios, { type AxiosRequestConfig } from 'axios';

export default async (customAgentId: string) => {
  const config: AxiosRequestConfig = {
    url: `/custom_agent/delete/${customAgentId}`,
    method: 'post',
  };

  await axios.request(config);
};
